import { render, staticRenderFns } from "./empty-application-handler.vue?vue&type=template&id=24d7ba02"
import script from "./empty-application-handler.vue?vue&type=script&lang=js"
export * from "./empty-application-handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports